/**
 * Travel Form Reducers
 */
import {
    TRAVELFORM_ACTION,
    ALL_TRAVELFORM,
    ADD_TRAVELFORM,
    FETCH_TRAVELFORM,
    MAIL_TRAVELFORM
 
 } from 'Actions/types';
 
 /**
  * initial auth user
  */
 const INIT_STATE = {
     travelformlist:[],
     travelformreport:[],
     travelformmail:[],
     loading: false
 };
 

 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
         case TRAVELFORM_ACTION:
             return { ...state, loading: true };
 
         case ALL_TRAVELFORM:
             return { ...state, loading: false, travelformlist: action.payload };  

         case ADD_TRAVELFORM:
                return { ...state, loading: false, }; 

        case FETCH_TRAVELFORM:
             return { ...state, loading: false, travelformreport: action.payload  }; 

        case MAIL_TRAVELFORM:
                return { ...state, loading: false, travelformmail: action.payload  };              
           
         default: return { ...state };
     }
 }

